<style>
.el-table_1_column_7 .cell,
.el-table_1_column_10 .cell {
    text-align: center;
}

.el-select-dropdown__item span,
.el-tag .el-select__tags-text {
    text-transform: capitalize;
}

.el-table_1_column_6 .cell {
    padding-left: 15px !important;
}

.el-table .warning-row,
.el-table table.el-table__body tr.el-table__row.warning-row > td {
    background: oldlace;
}

.more-css {
    font-size: 10px;
    background-color: purple;
    color: white;
    padding: 4px;
    border-radius: 2px;
}

.see-usage {
    background: aquamarine;
    padding: 2px;
    border-radius: 4px;
}
</style>
<style scoped>
.el-dropdown-menu__item {
    position: relative;
    margin-right: 10px;
}
.el-dropdown-menu__item > span:first-child {
    padding-right: 40px;
}

.content-wrapper .content {
    padding-top: 95px;
}

.heading-cart {
    position: relative;
    padding-left: 15px;
    padding-right: 15px;
}

.box-header .box-title {
    display: inline-block;
    font-size: 15px;
    padding: 10px;
    line-height: 1;
    color: black;
}

.heading-cart {
    margin-bottom: 0;
}
.el-button-small {
    padding: 0px;
    position: absolute;
    top: 10px;
    right: 25px;
}
.box-body {
    padding: 0px 20px 20px;
}

.el-button.edit {
    padding: 5px 10px;
}

.select-input {
    width: 100%;
}

.form-label {
    font-weight: bold;
    text-transform: capitalize;
}

button[disabled='disabled'],
button:disabled {
    background-color: rgba(200, 200, 200, 2.3);
    border-color: rgba(200, 200, 200, 2.3);
    cursor: not-allowed;
}
</style>
<template>
    <div class="content-wrapper">
        <section class="content">
            <div class="box">
                <div class="box-header with-border heading-cart">
                    <h3 class="box-title">Ad Spots</h3>
                    <div>
                        <el-input
                            style="display: inline-block; width: 80%; margin: 0 0 10px 10px"
                            data-vv-delay="1000"
                            name="searchFI"
                            type="text"
                            placeholder="search adspot by alias name (type and enter)"
                            v-model="searchFI"
                            @keyup.enter.native="filterFirstImpressionTagAssociations(searchFI)"
                        ></el-input>
                        <el-tooltip content="clearSearch" placement="top">
                            <el-button
                                type="danger"
                                icon="el-icon-close"
                                @click="clearSearch()"
                                style="display: inline-block"
                            >
                                <!-- <i class="el-icon-close"></i> -->
                            </el-button>
                        </el-tooltip>
                    </div>
                    <span
                        v-if="
                            domain_details.buckets && domain_details.buckets[0]
                                ? domain_details.buckets[0].features.indexOf('SELECTORS_AS_EXISTING') > -1
                                : false
                        "
                        style="
                            color: red;
                            font-style: italic;
                            background: yellow;
                            padding: 6px;
                            margin: 5px;
                            border-radius: 3px;
                            float: right;
                        "
                        >Note: For existing ad spot, selectors to be given (eg: div-gpt-30934894-1 -->
                        #div-gpt-30934894-1)</span
                    >
                </div>
                <div class="box-body">
                    <el-table
                        v-loading="loading"
                        :data="existingAdSpots"
                        height="355"
                        stripe
                        style="width: 100%; border-spacing: 0"
                        id="assoc-table"
                    >
                        <!--  -->
                        <el-table-column label="Alias Name" width="230" prop="alias_name">
                            <template slot-scope="props">
                                <span>{{ props.row.alias_name }}</span>

                                <br />
                                <!-- {{props.row.associations.length}} -->
                                <el-dropdown trigger="click" class="see-usage" @command="OpenAdSpotUsage">
                                    <span class="el-dropdown-link">
                                        See usage in bucket<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                            :command="{
                                                alias: props.row.alias_name,
                                                bucket_id: bucket.id,
                                                id: props.row.id,
                                            }"
                                            v-for="bucket in domain_details.buckets"
                                            :key="bucket.id"
                                        >
                                            <i
                                                v-if="isUsed(props.row.id, bucket.id)"
                                                style="position: absolute; left: 4px; top: 12px"
                                                class="el-icon-success"
                                            ></i>
                                            <span>{{ bucket.name }} </span>
                                            <span
                                                v-if="isUsed(props.row.id, bucket.id)"
                                                style="
                                                    position: absolute;
                                                    top: 50%;
                                                    transform: translateY(-50%);
                                                    right: -1px;
                                                "
                                            >
                                                <el-tooltip
                                                    content="Delete all assocations on the bucket"
                                                    placement="bottom"
                                                >
                                                    <button
                                                        type="button"
                                                        @click="deleteallTagsonBucket($event, bucket.id, props.row.id)"
                                                        class="el-button el-button--danger el-button-small"
                                                    >
                                                        <i style="font-size: 12px; padding: 3px" class="ti-trash"></i>
                                                    </button>
                                                </el-tooltip>
                                                <el-tooltip content="Push script for bucket" placement="bottom">
                                                    <a
                                                        href="javascript:void(0);"
                                                        class="upload"
                                                        @click.stop="createJs(bucket.id)"
                                                    >
                                                        <i class="el-icon-upload el-icon--right"></i>
                                                    </a>
                                                </el-tooltip>
                                            </span>
                                            <!-- <span>
                                                <el-tooltip
                                                    content="Delete all assocations on the bucket"
                                                    placement="bottom"
                                                >
                                                    <button
                                                        type="button"
                                                        @click="deleteallTagsonBucket($event, bucket.id, props.row.id)"
                                                        class="el-button el-button--danger el-button-small"
                                                    >
                                                        <i class="ti-trash"></i>
                                                    </button>
                                                </el-tooltip>
                                            </span> -->
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>

                                <br />
                                <span class="more-css" v-if="checkifMoreCssPresent(props.row.ad_unit_data)">
                                    MORE CSS
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Existing" width="90">
                            <template slot-scope="props">
                                <div v-if="props.row.is_existing" class="text-center">
                                    <svg
                                        data-v-7a40f996=""
                                        aria-hidden="true"
                                        height="20px"
                                        width="20px"
                                        data-prefix="far"
                                        data-icon="check-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        class="svg-inline--fa fa-check-circle fa-w-16 fa-2x"
                                    >
                                        <path
                                            data-v-7a40f996=""
                                            fill="green"
                                            d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                                        ></path>
                                    </svg>
                                </div>
                                <div v-if="!props.row.is_existing" class="text-center">
                                    <svg
                                        aria-hidden="true"
                                        height="20px"
                                        width="20px"
                                        data-prefix="fal"
                                        data-icon="times-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        class="svg-inline--fa fa-times-circle fa-w-16 fa-2x"
                                    >
                                        <path
                                            fill="red"
                                            d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
                                            class=""
                                        ></path>
                                    </svg>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="Unique Id / Ad Format">
                            <template slot-scope="props">
                                <span>{{
                                    getAdTypeName(props.row.fi_ad_type) != '-'
                                        ? getAdTypeName(props.row.fi_ad_type)
                                        : props.row.unique_id
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Layout">
                            <template slot-scope="props">
                                <span
                                    class="text-capitalize"
                                    v-if="props.row.associations.length != 0"
                                    v-for="(lay, index) in props.row.associations"
                                    :key="lay.id"
                                >
                                    {{
                                        lay.layout.layout_name + (index < props.row.associations.length - 1 ? ', ' : '')
                                    }}
                                </span>
                                <span class="text-capitalize" v-if="props.row.associations.length == 0">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="device">
                            <template slot-scope="props">
                                <span class="text-capitalize">
                                    <!-- {{ lay.layout.layout_name + ((index < (props.row.associations.length - 1)) ? ', ' : '') }} -->
                                    {{ props.row.device }}
                                </span>
                                <span class="text-capitalize" v-if="props.row.associations.length == 0">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Select" width="70">
                            <template slot-scope="props">
                                <div class="text-center">
                                    <input
                                        type="checkbox"
                                        v-model="props.row.checked"
                                        :disabled="props.row.isbucketused"
                                        @click="checkboxChange(props.row, props.row.checked)"
                                    />
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="Delete" width="70">
                            <template slot-scope="props">
                                <button
                                    class="el-button btn-rounded el-button--danger edit"
                                    type="button"
                                    :disabled="props.row.isbucketused"
                                    @click="deleteFirstImpression(props.row)"
                                >
                                    <i class="ti-trash"></i>
                                </button>
                            </template>
                        </el-table-column>
                        <el-table-column label="Edit" width="70">
                            <template slot-scope="props">
                                <button
                                    class="el-button btn-rounded el-button--success edit"
                                    :id="props.row.id"
                                    @click="editFirstImpression(props.row)"
                                >
                                    <i class="ti-pencil"></i>
                                </button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        style="text-align: center; margin-top: 30px"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :total="total_pages"
                        layout="sizes, prev, pager, next"
                        :page-size="offset"
                    >
                    </el-pagination>

                    <hr />
                    <div>
                        <el-button
                            type="danger"
                            class="btn-rounded float-right"
                            :disabled="cArr.length == 0"
                            @click="deleteSelectedFirstImpressions"
                        >
                            <i class="ti-trash"></i>Delete Multiple</el-button
                        >
                    </div>

                    <hr />

                    <form method="post" v-on:submit.prevent="saveAdSpots" class="form">
                        <div class="row clearfix">
                            <div class="col-md-1">
                                <p class="form-label">Existing</p>
                                <div class="m-t-15">
                                    <el-switch
                                        active-text=""
                                        inactive-text=""
                                        active-color="#13ce66"
                                        inactive-color="#ff4949"
                                        v-model="formData.existing"
                                    ></el-switch>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <p class="form-label">Alias Name</p>
                                <el-input
                                    class="publisher-input"
                                    name="aliasName"
                                    type="text"
                                    placeholder="Alias Name"
                                    v-model="formData.aliasName"
                                ></el-input>
                            </div>
                            <div class="col-md-3">
                                <p class="form-label">Select device</p>
                                <el-radio-group v-model="devicegroup" @input="changeValue" size="small">
                                    <el-radio-button label="mobile" value="devicegroup">Mobile</el-radio-button>
                                    <el-radio-button label="web" value="devicegroup">Web</el-radio-button>
                                    <el-radio-button label="tablet" value="devicegroup">Tablet</el-radio-button>
                                    <el-radio-button label="all" value="devicegroup">All</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div class="col-md-3" v-show="formData.existing">
                                <p class="form-label">Unique</p>
                                <el-input
                                    class="publisher-input"
                                    name="udivid"
                                    type="text"
                                    placeholder="Unique div id"
                                    v-model="formData.udivid"
                                ></el-input>
                            </div>
                            <div class="col-md-3" v-show="!formData.existing">
                                <p class="form-label">Select Ad Format</p>
                                <el-select
                                    class="select-input"
                                    filterable
                                    v-model="formData.fiAdType"
                                    placeholder="Choose ad format"
                                    @change="getAdFormatFields()"
                                >
                                    <el-option
                                        v-for="fiAdType in fiAdTypes"
                                        :key="fiAdType.id"
                                        :label="fiAdType.name"
                                        :value="fiAdType.id"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div class="col-md-4">
                                <p class="form-label">Layout</p>
                                <el-select
                                    class="publisher-input select-input"
                                    v-model="formData.adspotLayout"
                                    multiple
                                    collapse-tags
                                    filterable
                                    placeholder="Select layout"
                                    @change="selectLayoutEdit(formData)"
                                    @remove-tag="layoutTagRemoved(formData)"
                                >
                                    <el-option
                                        v-for="layout in existingLayouts"
                                        :key="layout.id"
                                        :label="layout.layout_name"
                                        :value="layout.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="col-md-1">
                                <p class="form-label">Def. Slot</p>
                                <div class="m-t-15">
                                    <el-switch
                                        active-text=""
                                        inactive-text=""
                                        active-color="#13ce66"
                                        inactive-color="#ff4949"
                                        v-model="formData.defineSlot"
                                    ></el-switch>
                                </div>
                            </div>
                        </div>
                        <div class="row clearfix" v-show="!formData.existing">
                            <div v-for="field in adFormatFields" :key="field.name" class="col-md-4 m-t-15">
                                <p class="form-label">
                                    {{ field.display_name }}
                                </p>

                                <el-input
                                    v-if="field.type == 'text'"
                                    type="text"
                                    :placeholder="field.display_name"
                                    :id="field.display_name"
                                    v-model="formData.adTypeData[field.name]"
                                ></el-input>

                                <el-input
                                    v-if="field.type == 'number'"
                                    type="number"
                                    :id="field.display_name"
                                    step="0.01"
                                    v-model.number="formData.adTypeData[field.name]"
                                ></el-input>

                                <div class="clearfix m-t-15 m-b-13" v-if="field.type == 'checkbox'">
                                    <el-switch
                                        v-model="formData.adTypeData[field.name]"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949"
                                        :for="field.display_name"
                                        active-text="Active"
                                        inactive-text="Inactive"
                                    ></el-switch>
                                </div>

                                <el-radio-group
                                    v-if="field.type == 'radio'"
                                    v-model="formData.adTypeData[field.name]"
                                    size="small"
                                >
                                    <el-radio-button :label="val.value" v-for="val in field.values" :key="val.value">{{
                                        val.display_name
                                    }}</el-radio-button>
                                </el-radio-group>
                            </div>
                        </div>

                        <div class="row m-t-15 clearfix text-right">
                            <div class="col-md-12">
                                <button
                                    class="el-button el-button--danger"
                                    type="button"
                                    v-show="formData.editId"
                                    @click="clearForm()"
                                >
                                    Cancel
                                </button>
                                <button
                                    class="el-button el-button--success"
                                    ref="changesSubmit"
                                    type="submit"
                                    :disabled="disableCheck(formData)"
                                >
                                    {{ formData.editId ? 'Update' : 'Save' }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            issearch: false,
            searchFI: '',
            currentPage: 1,
            offset: 10,
            cArr: [],
            id: '5603',
            total_pages: 0,
            uuid: undefined,
            domId: undefined,
            bucket_id: undefined,
            isHeader: false,
            divIdPrefix: 'fi-ash-',
            existingAdSpots: [],
            existingLayouts: [],
            allKeyValues: [],
            devicegroup: 'all',
            fiAdTypes: [],
            las: {},
            formData: {
                index: -1,
                editId: undefined,
                existing: true,
                defineSlot: false,
                udivid: undefined,
                selector: undefined,
                fiAdType: undefined,
                aliasName: undefined,
                keyValuePairAssoc: undefined,
                keyValue: [],
                adspotLayout: [],
                adTypeData: {},
                selectedLayouts: [],
            },
            adspotLayoutAssoc: {
                layoutSelected: [],
            },
            adFormatFields: [],
            loading: true,
        };
    },
    props: {
        domain_details: Object,
    },
    created: function () {
        var afterDeleteList = [];
        // console.log('domain_details');
        // console.log(this.domain_details);
        this.uuid = this.$route.params.uuid;
        this.domId = this.$route.params.domId;

        var viewApi = `${BASE_URL}v1/search-adspot/domain/${this.domId}/?query=${this.$route.query.spot_id}&&page=1&&offset=${this.offset}&&isId=0`;
        var searchApi = `${BASE_URL}v1/publishers/${this.uuid}/domains/${this.domId}/setup-fi-adspots/?page=1&&offset=10`;
        this.copyFormData = JSON.parse(JSON.stringify(this.formData));
        axios
            .all([
                axios.get(this.$route.query.spot_id ? viewApi : searchApi),
                axios.get(`${BASE_URL}v1/domains/${this.domId}/page-layouts/`),
                // axios.get(BASE_URL +'v1/domains/'+ this.domId +'/las/'),
                axios.get(`${BASE_URL}v1/get-all-fi-ad-types/`),
                axios.get(`${BASE_URL}v1/get-all-key-values/`),
            ])
            .then(
                axios.spread((adSpots, pageLayouts, fi_ad_types, keyValues) => {
                    console.log('route', this.$route.params.domId);

                    this.total_pages = adSpots.data.total;
                    for (var i = 0; i < adSpots.data.data.length; i++) {
                        adSpots.data.data[i].isbucketused = this.checkIsBucketUsed(adSpots.data.data[i]);
                        if (adSpots.data.data[i].status) {
                            afterDeleteList.push(adSpots.data.data[i]);
                        }
                        console.log('status', adSpots.data.data[i]);
                    }
                    // console.log('created adspot data', afterDeleteList.length);
                    this.existingAdSpots = afterDeleteList;
                    this.existingLayouts = pageLayouts.data;
                    this.fiAdTypes = fi_ad_types.data;
                    this.allKeyValues = keyValues.data;
                    this.loading = false;
                    this.$nextTick().then(() => {
                        // console.log('DOM updated!!!');
                        if (this.$route.query.spot_id) {
                            console.log('SPOT ID');
                            console.log(this.$route.query.spot_id);
                            let filtered_spot_index = this.existingAdSpots.findIndex((spot) => {
                                return spot.id == this.$route.query.spot_id;
                            });
                            if (filtered_spot_index != -1) {
                                // console.log(filtered_spot[0].alias_name);
                                let filtered_spot = this.existingAdSpots[filtered_spot_index];
                                console.log(filtered_spot.alias_name);
                                this.editFirstImpression(filtered_spot);
                                this.searchFI = adSpots.data.data[0].alias_name;
                                window.setTimeout(() => {
                                    jQuery('.el-table__body-wrapper:last').animate(
                                        {
                                            scrollTop: jQuery(
                                                `.el-table__body-wrapper .el-table__row:eq(${filtered_spot_index})`
                                            ).position().top,
                                        },
                                        600
                                    );
                                }, 300);
                            } else console.error('no ad spot found!!');
                        }
                    });
                })
            );
    },
    mounted: function () {
        this.$nextTick(function () {
            console.log('Entire DOM updated!!!');
        });
    },
    methods: {
        checkIsBucketUsed(adSpots) {
            var isbucketused = false;
            for (var j = 0; j < adSpots.associations.length; j++) {
                console.log('asso', adSpots.associations[j].fi_layout_bucket_associations.length);
                if (adSpots.associations[j].fi_layout_bucket_associations.length == 0) {
                    isbucketused = false;
                } else {
                    isbucketused = true;
                    break;
                }
            }
            return isbucketused;
        },
        clearSearch() {
            this.searchFI = '';
            this.loadAdspotDataByCurrentPage(1);
        },
        filterFirstImpressionTagAssociations() {
            this.issearch = true;
            this.currentPage = 1;
            this.loading = true;
            this.existingAdSpots = [];
            console.log('search string', this.searchFI, typeof this.searchFI);

            var searchApi = `${BASE_URL}v1/search-adspot/domain/${this.domId}/?query=${this.searchFI}&&page=1&&offset=${this.offset}&&isId=1`;
            axios.get(searchApi).then((response) => {
                for (var i = 0; i < response.data.data.length; i++) {
                    response.data.data[i].isbucketused = this.checkIsBucketUsed(response.data.data[i]);
                }
                this.existingAdSpots = response.data.data;
                this.total_pages = response.data.total;
                console.log('total_pages', this.total_pages);
                this.loading = false;
            });
        },
        loadAdspotDataByCurrentPage(pageNum) {
            console.log('pagenum', pageNum);
            this.loading = true;
            const cancelToken = axios.CancelToken;
            if (this.cancelRequest) this.cancelRequest.cancel('Operation canceled by the user.');
            this.cancelRequest = cancelToken.source();
            this.existingAdSpots = [];

            axios
                .get(
                    `${BASE_URL}v1/publishers/${this.uuid}/domains/${this.domId}/setup-fi-adspots/?page=${pageNum}&&offset=${this.offset}`,
                    {
                        cancelToken: this.cancelRequest.token,
                    }
                )
                .then((res) => {
                    console.log('data', res.data);
                    for (var i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isbucketused = this.checkIsBucketUsed(res.data.data[i]);
                    }
                    this.existingAdSpots = res.data.data;
                    this.total_pages = res.data.total;
                    this.loading = false;
                })
                .catch((err) => {
                    if (axios.isCancel(err)) {
                        console.log('First Request canceled', err.message);
                    } else {
                        console.log('error', err);
                    }
                })
                .finally(() => {});
        },
        handleCurrentChange(val) {
            console.log('Current page', val);
            this.currentPage = val;
            if (this.issearch) {
                this.filterFirstImpressionTagAssociations();
            } else {
                this.loadAdspotDataByCurrentPage(val);
            }
        },

        handleSizeChange(val) {
            console.log('Size changed: ', val);
            this.offset = val;
            this.loadAdspotDataByCurrentPage(1);
            this.currentPage = 1;
        },

        deleteFirstImpression(adspot) {
            this.$confirm('This will permanently delete Adspot. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning',
            })
                .then(() => {
                    this.$message({
                        type: 'success',
                        message: 'Ad spot Deleted',
                        action: this.deleteLogicForFirstImpressionadspot(adspot),
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled',
                    });
                });
        },
        deleteLogicForFirstImpressionadspot(adspot) {
            var api = BASE_URL + `v1/delete-adspot/${adspot.id}/`;

            console.log('adspot', adspot);
            let x = {
                status: false,
            };
            axios.post(api, x).then((res) => {
                console.log('res', res);
                console.log('type', typeof this.existingAdSpots);
                console.log('type', this.existingAdSpots.length);

                let index = this.existingAdSpots.indexOf(adspot);
                console.log('this.existingAdSpots.indexOf(adspot) delee', this.existingAdSpots.indexOf(adspot));

                this.existingAdSpots.splice(index, 1);

                console.log('index dele', this.existingAdSpots);
            });
        },
        changeValue(label) {
            console.log('label', label);
        },
        clearForm() {
            this.formData = JSON.parse(JSON.stringify(this.copyFormData));
            this.devicegroup = 'all';
        },
        getAdTypeName(fi_ad_type_id) {
            let i = 0;
            for (; i < this.fiAdTypes.length; i++)
                if (this.fiAdTypes[i].id == fi_ad_type_id) return this.fiAdTypes[i].name;

            return '-';
        },
        checkifMoreCssPresent(ad_unit_data) {
            ad_unit_data = JSON.parse(ad_unit_data);
            return ad_unit_data.mcss && ad_unit_data.mcss !== '';
        },
        layoutTagRemoved(data) {
            this.formData.keyValue.forEach((val, index, arr) => {
                if (this.formData.adspotLayout.indexOf(index) == -1) {
                    arr[index] = '';
                }
            });
        },
        selectLayout(adspot) {
            this.selectLayoutEdit(adspot);
            if (adspot)
                for (let i = 0; i < adspot.associations.length; i++)
                    this.formData.keyValue[adspot.associations[i].layout.id] = undefined;
        },
        selectLayoutEdit(adspot) {
            let tempArray = [];
            for (let i = 0; i < this.formData.adspotLayout.length; i++)
                for (let j = 0; j < this.existingLayouts.length; j++)
                    if (this.formData.adspotLayout[i] == this.existingLayouts[j].id) {
                        tempArray.push(JSON.parse(JSON.stringify(this.existingLayouts[j])));
                        if (!adspot) this.formData.keyValue[this.formData.adspotLayout[i]] = '';
                        break;
                    }

            this.formData.selectedLayouts = tempArray;
        },
        disableCheck(data) {
            let allLayoutVal = false;
            let formData = data;
            let k = data.keyValue.filter((t, index) => {
                return data.adspotLayout.indexOf(index) != -1;
            });
            // console.log(k,'filtered')
            k.map((y) => {
                if (typeof y == 'number') {
                    allLayoutVal = true;
                }
            });
            k.map((y) => {
                if (typeof y != 'number' || k.length != data.adspotLayout.length) {
                    allLayoutVal = true;
                }
            });

            // console.log(allLayoutVal,'test')
            if (
                (formData.existing && (!formData.aliasName || !formData.udivid || formData.adspotLayout.length == 0)) ||
                (!formData.fiAdType && formData.adspotLayout.length == 0) ||
                !formData.aliasName
            ) {
                return true;
            } else {
                return false;
            }
        },
        getAdFormatFields(adspot) {
            let adTypeFields = {};
            console.log('fiaddtypes', this.fiAdTypes);
            for (let i = 0; i < this.fiAdTypes.length; i++)
                if (this.fiAdTypes[i].id == this.formData.fiAdType) {
                    adTypeFields = this.fiAdTypes[i];
                    break;
                }

            if (adTypeFields && adTypeFields.data_fields) {
                let fields = JSON.parse(adTypeFields.data_fields);
                if (!this.formData.editId) {
                    let tempObject = {};
                    for (let i = 0; i < fields.length; i++)
                        if (fields[i].type != 'checkbox' && fields[i].type != 'radio')
                            tempObject[fields[i].name] = fields[i].value;
                        else {
                            if (fields[i].type == 'checkbox')
                                if (fields[i].value === undefined || !fields[i].value)
                                    tempObject[fields[i].name] = false;
                                else tempObject[fields[i].name] = true;
                            else tempObject[fields[i].name] = fields[i].value;
                        }

                    this.formData.adTypeData = tempObject;
                } else if (adspot && adspot.ad_unit_data) this.formData.adTypeData = JSON.parse(adspot.ad_unit_data);

                this.adFormatFields = fields;

                if (adTypeFields.name == 'Header') {
                    this.isHeader = true;
                }
            }
        },
        tableRowClassName() {
            jQuery('#assoc-table').find('.warning-row').removeClass('warning-row');
            if (this.formData.index > -1)
                jQuery('#assoc-table').find('table>tbody').find('tr').eq(this.formData.index).addClass('warning-row');
        },
        editFirstImpression(adspot) {
            console.log('editimpression');
            console.log('adspot', adspot);
            this.formData.aliasName = adspot.alias_name;
            this.formData.index = this.existingAdSpots.indexOf(adspot);
            console.log('this.existingAdSpots.indexOf(adspot)', this.existingAdSpots.indexOf(adspot));
            console.log('index', this.formData.index);
            this.formData.editId = adspot.id;
            this.formData.existing = adspot.is_existing;
            this.formData.udivid = adspot.unique_id;
            this.formData.selector = adspot.selector;
            this.formData.fiAdType = adspot.fi_ad_type;
            this.formData.defineSlot = adspot.define_slot;

            this.formData.adspotLayout = [];

            for (let i = 0; i < adspot.associations.length; i++) {
                this.formData.adspotLayout.push(adspot.associations[i].layout.id);
                console.log('adspot.associations[i].ad_spot.device:=', adspot.associations[i].ad_spot.device);
                this.devicegroup = adspot.associations[i].ad_spot.device;
            }
            console.log('devicegroup:=', this.devicegroup);
            this.selectLayout(adspot);
            this.getAdFormatFields(adspot);
            this.tableRowClassName();
        },
        saveAdSpots() {
            var layoutKeyValueMap = {};
            var p = this.formData.keyValue;
            for (var key in p) {
                if (p.hasOwnProperty(key)) {
                    layoutKeyValueMap[key] = p[key];
                }
            }

            if (this.isHeader == true) {
                this.formData.adTypeData['vanish_req'] = false;
                if (this.formData.adTypeData['vanish']) {
                    this.formData.adTypeData['vanish_req'] = true;
                }

                this.formData.adTypeData['Off_req'] = false;
                if (this.formData.adTypeData['offTime']) {
                    this.formData.adTypeData['Off_req'] = true;
                }

                this.formData.adTypeData['lazyLoad'] = false;
                if (this.formData.adTypeData['lazyElm']) {
                    this.formData.adTypeData['lazyLoad'] = true;
                }
            }

            let dataObject = {
                alias_name: this.formData.aliasName,
                status: true,
                device: this.devicegroup,
                define_slot: this.formData.defineSlot,
                domain: this.domId,
                id: this.formData.editId,
                is_existing: this.formData.existing,
                unique_id: this.formData.existing
                    ? this.formData.udivid
                    : this.divIdPrefix +
                      Math.round(new Date().getTime() / 1000) +
                      '-' +
                      Math.floor(Math.random() * 1000) +
                      1,
                selector: this.formData.selector ? this.formData.selector : 'n/a',
                fi_ad_type: this.formData.fiAdType ? this.formData.fiAdType : undefined,
                ad_unit_data: JSON.stringify(this.formData.adTypeData),
                layouts: this.formData.adspotLayout,
                // keys: this.formData.keyValuePairAssoc,
                keys: layoutKeyValueMap,
            };

            console.log(dataObject);

            axios
                .post(
                    BASE_URL + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/setup-fi-adspots/',
                    dataObject
                )
                .then((response) => {
                    if (this.formData.editId) {
                        this.existingAdSpots[this.formData.index].alias_name = dataObject.alias_name;
                        this.existingAdSpots[this.formData.index].unique_id = dataObject.unique_id;
                        this.existingAdSpots[this.formData.index].is_existing = dataObject.is_existing;
                        this.existingAdSpots[this.formData.index].selector = dataObject.selector;
                        this.existingAdSpots[this.formData.index].ad_unit_data = response.data.data.ad_unit_data;
                        this.existingAdSpots[this.formData.index].define_slot = dataObject.define_slot;
                        this.existingAdSpots[this.formData.index].associations = response.data.associations;
                        this.existingAdSpots[this.formData.index].fi_ad_type = response.data.data.fi_ad_type;
                        this.existingAdSpots[this.formData.index].device = response.data.data.device;
                    } else {
                        this.existingAdSpots.push({
                            alias_name: dataObject.alias_name,
                            unique_id: dataObject.unique_id,
                            is_existing: dataObject.is_existing,
                            selector: dataObject.selector,
                            id: response.data.data.id,
                            ad_unit_data: response.data.data.ad_unit_data,
                            fi_ad_type: response.data.data.fi_ad_type,
                            define_slot: dataObject.define_slot,
                            associations: response.data.associations,
                            device: response.data.data.device,
                        });
                    }
                    this.$notify({
                        title: 'Success',
                        message:
                            'Ad-spot has been ' + (this.formData.editId ? 'created' : 'updated') + ' successfully.',
                        type: 'success',
                    });
                    this.clearForm();
                    this.tableRowClassName();
                });
        },
        OpenAdSpotUsage(command) {
            console.log('command', command);
            setTimeout(() => {
                let url = `/admin/publisher/${this.uuid}/domain/${this.domId}/buckets/${command.bucket_id}/fi/?adSpotId=${command.id}`;
                console.log('command url', url);
                this.$router.push(url);
            });
        },
        isUsed(adspot_id, bucket_id) {
            let adspot = this.existingAdSpots.find((adspot) => adspot.id == adspot_id),
                used_bucket_ids = [];
            if (adspot['associations'].length > 0) {
                adspot['associations'].forEach((association) => {
                    association['fi_layout_bucket_associations'].forEach((fiBucketAsso) => {
                        if (!used_bucket_ids.includes(fiBucketAsso.bucket_id))
                            used_bucket_ids.push(fiBucketAsso.bucket_id);
                    });
                });
                // let used_bucket_ids = adspot['associations'][0]['fi_layout_bucket_associations'].map((fiBucketAsso) => fiBucketAsso.bucket_id);
                console.log('used_bucketids', used_bucket_ids);
                return used_bucket_ids.includes(bucket_id);
            } else return false;
        },
        createJs(bucket_id) {
            axios
                .post(BASE_URL + 'v1/cdn_push/', {
                    bucketId: bucket_id,
                })
                .then((response) => {
                    var type = 'Error',
                        message = 'Oops Something went wrong!';
                    if (response.data.response_data.status) {
                        type = 'Success';
                        message = response.data.response_data.message;
                    } else {
                        type = 'Error';
                        message = response.data.response_data.message;
                    }
                    this.$notify({
                        title: type,
                        message: message,
                        type: type.toLowerCase(),
                    });
                });
        },
        checkboxChange(adspot) {
            console.log(adspot);
            //console.log(status)
            let vm = this;
            setTimeout(function () {
                if (adspot.checked == true) {
                    vm.cArr.push(adspot);
                } else if (adspot.checked == false) {
                    vm.cArr.splice(vm.cArr.indexOf(adspot), 1);
                }
                console.log(vm.cArr);
            }, 300);
        },
        deleteSelectedFirstImpressions() {
            let vm = this;
            let selectedAdspots = [];
            vm.cArr.forEach(function (adspot) {
                selectedAdspots.push(adspot);
            });
            console.log(selectedAdspots);
            //var api = BASE_URL + `v1/delete-adspot/${adspot.id}/`;
            var apiArr = [];
            let x = {
                status: false,
            };
            for (var i = 0; i < selectedAdspots.length; i++) {
                apiArr.push(BASE_URL + `v1/delete-adspot/${selectedAdspots[i].id}/`);
            }
            this.$confirm('Are you sure you want to delete the selected adspots?', 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
            })
                .then(() => {
                    axios
                        .all(apiArr.map((api) => axios.post(api, x)))
                        .then((data) => {
                            console.log(data);
                            this.existingAdSpots = this.existingAdSpots.filter((adspot) => {
                                return !selectedAdspots.includes(adspot);
                            });
                            console.log(this.existingAdSpots);
                            vm.$notify({
                                title: 'Success',
                                message: 'Ad-spots has been deleted successfully.',
                                type: 'success',
                            });
                        })
                        .catch(() => {
                            vm.$notify({
                                title: 'Cancelled',
                                message: 'Delete has been cancelled.',
                                type: 'info',
                            });
                        });
                })
                .catch(() => {
                    vm.$notify({
                        title: 'Cancelled',
                        message: 'Action has been cancelled.',
                        type: 'info',
                    });
                });
        },
        deleteallTagsonBucket(event, bucket_id, adSpotId) {
            //    console.log("bucket ID",bucket_id);
            //    console.log("Event",event);
            let vm = this;
            let allAssociations = [];
            let association_ids = [];
            axios
                .get(
                    `${BASE_URL}v1/publishers/${this.uuid}/domains/${this.domId}/buckets/${bucket_id}/adspot-tag-association/`
                )
                .then((response) => {
                    allAssociations = response.data.data.filter((assoc) => {
                        return assoc.layout.ad_spot.id == adSpotId;
                    });
                    allAssociations.forEach((association) => {
                        association_ids.push(association.id);
                    });
                    console.log('association_ids', association_ids);
                });
            console.log('association_ids', association_ids);

            this.$confirm(
                'Are you sure you want to delete all tag associations made using this ad spot in this bucket?',
                'Warning',
                {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    type: 'warning',
                }
            )
                .then(() => {
                    axios
                        .all(
                            association_ids.map((association_id) => {
                                return axios.delete(
                                    `${BASE_URL}v1/publishers/${this.uuid}/domains/${this.domId}/buckets/${bucket_id}/adspot-tag-association/?assoc_id=${association_id}`
                                );
                            })
                        )
                        .then((data) => {
                            console.log(data);
                            vm.$notify({
                                title: 'Success',
                                message: 'All tag associations deleted successfully',
                                type: 'success',
                            });
                            this.loadAdspotDataByCurrentPage(this.currentPage);
                        })
                        .catch(() => {
                            vm.$notify({
                                title: 'Cancelled',
                                message: 'Delete has been cancelled.',
                                type: 'info',
                            });
                        });
                })
                .catch(() => {
                    vm.$notify({
                        title: 'Cancelled',
                        message: 'Action has been cancelled.',
                        type: 'info',
                    });
                }),
                event.stopPropagation();
        },
    },
};
</script>



// WEBPACK FOOTER //
// FiSetupAdSpots.vue?3bf3dc28